(function () {
  var params = new URLSearchParams(window.location.search);
  var campaign = params.get('utm_campaign');
  var h1El = document.querySelector('[data-campaign-h1]');
  var descEl = document.querySelector('[data-campaign-description]');

  function reveal() {
    if (h1El) h1El.style.visibility = 'visible';
    if (descEl) descEl.style.visibility = 'visible';
  }

  if (!window.campaignCopyMap || !campaign) {
    reveal();
    return;
  }

  var copy = window.campaignCopyMap[campaign];

  if (copy) {
    if (copy.h1 && h1El) h1El.textContent = copy.h1;
    if (copy.description && descEl) {
      descEl.textContent = copy.description;
    }
  }

  reveal();
})();
